import api from './api';

export interface Product {
  _id: string;
  name: string;
  description: string;
  price: number;
  quantity: number;
  image?: string;
  startSaleDate?: string;
  endSaleDate?: string;
  eventId: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProductStats {
  totalProducts: number;
  totalSales: number;
  totalRevenue: number;
  productsWithLowStock: number;
  productsOutOfStock: number;
}

export interface CreateProductData {
  eventId: string;
  name: string;
  description: string;
  price: number;
  quantity: number;
  startSaleDate?: string;
  endSaleDate?: string;
}

export interface UpdateProductData {
  name: string;
  description: string;
  price: number;
  quantity: number;
  startSaleDate?: string;
  endSaleDate?: string;
}

// Buscar produtos por evento
export const getProductsByEvent = async (eventId: string) => {
  try {
    const response = await api.get(`/dashboard/products/event/${eventId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produtos do evento:', error);
    throw new Error('Falha ao buscar produtos do evento');
  }
};

// Buscar estatísticas de produtos
export const getProductStats = async (eventId: string) => {
  try {
    const response = await api.get(`/dashboard/products/event/${eventId}/stats`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estatísticas de produtos:', error);
    throw new Error('Falha ao buscar estatísticas de produtos');
  }
};

// Buscar produto por ID
export const getProductById = async (id: string) => {
  try {
    const response = await api.get(`/dashboard/products/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produto:', error);
    throw new Error('Falha ao buscar produto');
  }
};

// Criar produto
export const createProduct = async (data: CreateProductData) => {
  try {
    const response = await api.post('/dashboard/products', data);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar produto:', error);
    throw new Error('Falha ao criar produto');
  }
};

// Atualizar produto
export const updateProduct = async (id: string, data: UpdateProductData) => {
  try {
    const response = await api.put(`/dashboard/products/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar produto:', error);
    throw new Error('Falha ao atualizar produto');
  }
};

// Deletar produto
export const deleteProduct = async (id: string) => {
  try {
    const response = await api.delete(`/dashboard/products/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao deletar produto:', error);
    throw new Error('Falha ao deletar produto');
  }
}; 